const todoTracking = {
	
	init() { 
		todoTracking.addListeners()
	},
	
	addListeners() {
		window.addEventListener('click', e => {
			console.log(e.target);
		})
	 }
}

document.addEventListener('DOMContentLoaded', todoTracking.init)